/**
 * Pay-and-bind flow status + post-bind result fields.
 * Owns the Payment page's submit button state and the BinderInvoice /
 * CompleteOrder pages' "what was bound" summary inputs.
 */
class BindStore {
  #listeners = new Set();

  #bindLoading = false;
  #bindError = null;
  #boundTotalAmount = null;
  #boundPolicyNumberFromInvoice = null;
  #signBinderLoading = false;
  #signBinderError = null;

  get bindLoading() { return this.#bindLoading; }
  set bindLoading(v) { this.#bindLoading = !!v; this.#notify(); }

  get bindError() { return this.#bindError; }
  set bindError(v) { this.#bindError = v; this.#notify(); }

  get boundTotalAmount() { return this.#boundTotalAmount; }
  set boundTotalAmount(v) { this.#boundTotalAmount = v; this.#notify(); }

  get boundPolicyNumberFromInvoice() { return this.#boundPolicyNumberFromInvoice; }
  set boundPolicyNumberFromInvoice(v) { this.#boundPolicyNumberFromInvoice = v; this.#notify(); }

  get signBinderLoading() { return this.#signBinderLoading; }
  set signBinderLoading(v) { this.#signBinderLoading = !!v; this.#notify(); }

  get signBinderError() { return this.#signBinderError; }
  set signBinderError(v) { this.#signBinderError = v; this.#notify(); }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  clear() {
    this.#bindLoading = false;
    this.#bindError = null;
    this.#boundTotalAmount = null;
    this.#boundPolicyNumberFromInvoice = null;
    this.#signBinderLoading = false;
    this.#signBinderError = null;
    this.#notify();
  }
}

const bindStore = new BindStore();
export default bindStore;
